import { render, staticRenderFns } from "./offerDetail.vue?vue&type=template&id=042a8924"
import script from "./offerDetail.vue?vue&type=script&lang=js"
export * from "./offerDetail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/offerDetail.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../assets/css/offer-detail-mobile.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports